export enum ChartEvents {
    DRAWING_ACTIVE = 'DRAWING_ACTIVE',
    DRAWING_INACTIVE = 'DRAWING_INACTIVE',
    DRAWING_FOCUSED = 'DRAWING_FOCUSED',
    OPEN_DRAWING_SETTINGS = 'OPEN_DRAWING_SETTINGS',
    DRAWING_DESTROYED = 'DRAWING_DESTROYED',
    DRAWING_HOVERED = 'DRAWING_HOVERED',
    REMOVE_DRAWING = 'REMOVE_DRAWING',
    CORPORATE_CLICKED = 'CORPORATE_CLICKED',
    CONTRACT_SWITCH_CLICKED = 'CONTRACT_SWITCH_CLICKED',
    COMPANY_EVENT_CLICKED = 'COMPANY_EVENT_CLICKED',
    NEWS_ARTICLE_CLICKED = 'NEWS_ARTICLE_CLICKED',
    CHART_ORDER_ACTION_CLICKED = 'CHART_ORDER_ACTION_CLICKED',
    CHART_ORDER_MARKER_CLICKED = 'CHART_ORDER_MARKER_CLICKED',
    CHART_ALERT_ON_CHART_PRICE_COMMIT = 'CHART_ALERT_ON_CHART_PRICE_COMMIT',
    CHART_ALERT_ON_CHART_CREATE_COMMIT = 'CHART_ALERT_ON_CHART_CREATE_COMMIT',
    CHART_ALERT_ON_CHART_DELETE = 'CHART_ALERT_ON_CHART_DELETE',
    CHART_ALERT_ON_CHART_RESTART = 'CHART_ALERT_ON_CHART_RESTART',
    CHART_ALERT_ON_CHART_EDIT = 'CHART_ALERT_ON_CHART_EDIT',
    SERIES_METADATA_ROW_ACTIVATED = 'SERIES_METADATA_ROW_ACTIVATED',
}